import React from 'react'
import Page from 'components/LayoutComponents/Page'
import Login from './Login'

class LoginPage extends React.Component {
  static defaultProps = {
    pathName: 'Login',
    roles: ['agent', 'administrator'],
  }

  render() {
    const props = this.props
    return (
      <Page {...props}>
        <Login />
      </Page>
    )
  }
}

export default LoginPage



// WEBPACK FOOTER //
// ./src/containers/LoginPage/index.js